import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService, TranslateService } from '@devinforius/i-essentials';
import { environment } from '@environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { EMPTY } from 'rxjs';

export const HttpTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const oAuthService = inject(OAuthService);
  // Résolution paresseuse : injecter ToasterService/TranslateService en tête créerait
  // une dépendance circulaire HttpClient -> intercepteur -> ToasterService ->
  // TranslateService -> HttpClient (NG0200). On les résout uniquement si besoin,
  // une fois HttpClient pleinement construit.
  const injector = inject(Injector);

  if (
    req.url.startsWith(environment.api.root) &&
    !oAuthService.hasValidAccessToken()
  ) {
    const toasterService = injector.get(ToasterService);
    const translateService = injector.get(TranslateService);
    const router = injector.get(Router);

    toasterService.push(
      'error',
      translateService.translate('global.error'),
      translateService.translate('auth.error.disconnected-info'),
    );
    router.navigate(['authentication']);

    return EMPTY;
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
    },
  });

  return next(authReq);
};
